var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.492 -65.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39.612,94.652a7.72,7.72,0,0,0-7.534-7.384h-2.021A5.751,5.751,0,0,0-45.4,81.877l.013-1.639a5.712,5.712,0,0,0-5.585-5.77A5.759,5.759,0,0,0-56.6,80.219l-.013,1.64a5.708,5.708,0,0,0,3.709,5.409h-2.013a7.7,7.7,0,0,0-7.571,7.414v4.189a6.359,6.359,0,0,0,4.859,5.567v11.137a.75.75,0,0,0,.75.75H-45.22a.75.75,0,0,0,.75-.75V104.346c2.378-.617,4.858-3.267,4.858-5.475ZM-55.117,81.875l.013-1.646a4.258,4.258,0,0,1,4.13-4.261,4.2,4.2,0,0,1,4.084,4.253l-.013,1.647a4.265,4.265,0,0,1-4.15,4.262A4.2,4.2,0,0,1-55.117,81.875Zm14.005,17c0,1.4-1.744,3.286-3.358,3.9V93.851h-1.5v20.974h-4.269V100.389h-1.5v14.436h-4.394V93.851h-1.5V102.9a4.913,4.913,0,0,1-3.359-4.029V94.682c0-3.664,3.536-5.914,6.071-5.914h7.758a6.2,6.2,0,0,1,6.051,5.914Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.7,97.517h-5.608V88.993h1.5v7.024H-28.7Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.564,114.019a17.274,17.274,0,0,1-9.138-2.6l.794-1.273a15.866,15.866,0,0,0,16.689,0,15.789,15.789,0,0,0,5.038-21.728A15.67,15.67,0,0,0-30,81.4a15.664,15.664,0,0,0-11.907,1.981l-.794-1.273a17.3,17.3,0,0,1,23.8,5.517,17.292,17.292,0,0,1-5.519,23.794A17.267,17.267,0,0,1-33.564,114.019Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.557,109.179a11.989,11.989,0,0,1-6.495-2l.83-1.25a10.474,10.474,0,0,0,5.674,1.754,10.924,10.924,0,0,0,10.892-10.9,10.837,10.837,0,0,0-3.189-7.719,10.84,10.84,0,0,0-7.714-3.2h-.012a10.52,10.52,0,0,0-6.548,2.295l-.937-1.172a12.031,12.031,0,0,1,7.485-2.623h.014A12.331,12.331,0,0,1-24.783,88a12.334,12.334,0,0,1,3.627,8.781A12.427,12.427,0,0,1-33.557,109.179Z",
    fill: "#1d1d1b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeWork);
export default __webpack_public_path__ + "static/media/time_work.9907fd6fd34017fd347317cd341f3dca.svg";
export { ForwardRef as ReactComponent };